'use strict';

import UIRouter from "@uirouter/angularjs";
import "angular-bootstrap-contextmenu";
import "angular1-async-filter"
import "font-awesome/css/font-awesome.css"
// Webpack needs to bundle css by 'require/import'
import "../polyfills";
import Accounts from "./account";
import AccountOpening from "./account-opening";
import Adviser from "./adviser";
import Analytics from "./analytics";
import {AnalyticsType} from "./analytics/models/AnalyticsType";
import Brokerage from "./brokerage";
import CompanyInfo from "./company-information";
import Components from "./components";
import Dashboard from "./dashboard";
import {DashboardView} from "./dashboard/oms/view/DashboardViewComponent";
import Depth from "./depth";
import Dividends from "./dividends";
import Favicon from "./favicon";
import Game from "./game";
import Helpers from "./help";
import IInvest from "./iinvest";
import Instruments from "./instruments";
import JS from "./js";
import Wizard from "./js/components/wizard";
import Directives from "./js/directives";
import {NVD3Util} from "./js/util/NVD3Util";
import {isNotNull} from "./js/util/UtilFunctions";
import Layout from "./layout";
import Market from "./market";
import Nav from "./nav";
import News from "./news";
import Notifications from "./notifications";
import Options from "./options";
import Orders from "./orders";
import {OrdersView} from "./orders/view/OrdersViewComponent";
import AccountPerformance from "./performance";
import Ticket from "./portfolio/templates/ticket";
import PositionSearch from "./positionSearch";
import Quote from "./quote";
import Risk from "./risk";
import Security from "./security";
import Services from "./services";
import Om from "./skin/om";
import OpenTrader from "./skin/open-trader";
import Span from "./span";
import StockScreener from "./stock-screener";
import Store from "./store";
import StrategyBuilder from "./strategybuilder";
import Stripe from "./stripe";
import Swift from "./swift";
import SystemMessages from "./system-messages";
import TechnicalIndicators from "./technical-indicators";
import Theming from "./theming";
import Tmc from "./tmc";
import TradeSimulator from "./trade-simulator";
import TradingAlerts from "./trading-alerts";
import TradingIdeas from "./trading-ideas";
import TradingSystems from "./trading-systems";
import Translation from "./translation";
import {TranslationsLanguage} from "./translation/config/TranslationsLanguage";
import {Branding, getAccountOpeningPath} from "./types/Branding";
import Watchlist from "./watchlist";

require('../assets/css/tf.scss');
require('../assets/css/navigation.css');
require('../vendor/angular-tour-tf/0.1.20/ng-joyride.scss');
require('../assets/css/profile.css');
require('../assets/css/intro-wizard.css');
require('../assets/css/process.css');
require('../assets/css/admin.css');
require('../assets/css/z-overrides.css');
require('../assets/css/tradeon.scss');

// import another scss at style.scss
require('./style.scss');

var ErrorUtil = require('./js/error.utils');
var getHttpErrorDetails = ErrorUtil.getHttpErrorDetails;

var app = angular.module('tfApp', [
    'asyncFilter',
    'ngStorage',
    'angular-loading-bar',
    'appConfig',
    'ngResource',
    'ngTouch',
    'ngSanitize',
    'draggabilly',
    'ngAnimate',
    'angularMoment',
    'ui.grid',
    'ngImgCrop',
    'ui.grid.resizeColumns',
    'ui.grid.draggable-rows',
    'ui.grid.saveState',
    'ui.grid.autoResize',
    'ui.grid.exporter',
    'ui.grid.grouping',
    'ui.grid.moveColumns',
    'ui.grid.selection',
    'ui.grid.pinning',
    'ui.grid.treeView',
    'angular-growl',
    'ngPasswordStrength',
    'validation.match',
    'credit-cards',
    'angular-stripe',
    "nvd3",
    'youtube-embed',
    'ngVimeo',
    'easypiechart',
    'duScroll',
    'ui.bootstrap',
    'ui.bootstrap.contextMenu',
    'ngAside',
    'slick',
    'rzModule',
    'angular-flipclock',
    'ngJoyRide',
    'matchMedia',
    'gridster',
    'myApp.chart.chart-directive',
    'jQueryScrollbar',
    'FBAngular',
    UIRouter,
    'ui.validate',
    'ngtweet',
    'tf.directives',
    'tf.controllers',
    'tf.services',
    'tf.filters',
    'tf.terms',
    'tf.optnChain',
    'tf.blotter',
    'tf.admin',
    'tf.process',
    'tf.settings',
    'tf.options.service',
    'tf.nav',
    'tf.qty.directive',
    'tf.watchlist',
    'tf.home',
    'tf.game',
    'tf.tradeOn',
    'tf.quiz',
    'tf.chain',
    'tf.profile',
    'tf.portfolio',
    'tf.volatility',
    'tf.audit',
    'tf.tradingTools',
    'tf.hedgeHelper',
    'tf.tradeSearch',
    'tf.distStrategy',
    'tf.strategy',
    'tf.portfolio.marginSummary',
    'tf.portfolio.floatingMenu',
    'tf.legal',
    'tf.photoUpload',
    'tf.popups',
    'tf.optionsCookbook',
    'tf.stockScreener',
    'tf.charting',
    'tf.tradingPortal',
    'tf.datePicker',
    'tf.gamePopups',
    'tf.brokerDisclaimer',
    'tf.brokerageOffer',
    'tf.addAccount',
    'tf.support',
    'tf.alerts',
    'ngWizard',
    'ngTagsInput',
    'dropzone',
    'angularFileUpload',
    'ngIdle',
    'focus-if',
    'ui.mask',
    'uiSwitch',
    'mailchimp',
    AccountOpening,
    Adviser,
    Analytics,
    Brokerage,
    CompanyInfo,
    StockScreener,
    Components,
    Dashboard,
    Directives,
    Dividends,
    Favicon,
    Game,
    Helpers,
    IInvest,
    Instruments,
    JS,
    Layout,
    Market,
    News,
    Notifications,
    Om,
    OpenTrader,
    Options,
    Orders,
    PositionSearch,
    Accounts,
    Depth,
    Quote,
    Risk,
    Security,
    Services,
    Span,
    Store,
    StrategyBuilder,
    Stripe,
    Swift,
    SystemMessages,
    TechnicalIndicators,
    Theming,
    Tmc,
    Ticket,
    TradeSimulator,
    TradingAlerts,
    TradingIdeas,
    TradingSystems,
    Translation,
    AccountPerformance,
    Wizard,
    Nav,
    Watchlist
])
    .run(['amMoment', function (amMoment) {
        amMoment.changeLocale('en');
    }])
    .config(['$compileProvider', function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
        $compileProvider.commentDirectivesEnabled(false);
        $compileProvider.cssClassDirectivesEnabled(false);
    }])
    .config(['stripeProvider', 'userConfigProvider', function (stripeProvider, userConfigProvider) {
        stripeProvider.setPublishableKey(userConfigProvider.config.stripePublishableKey);
    }])
    .config(['$provide', '$httpProvider', function ($provide, $httpProvider) {
        // Intercept http calls.
        $provide.factory('ErrorHttpInterceptor', ['$q', '$log', '$injector', function ($q, $log, $injector) {
            function notifyError(rejection) {
                if (rejection.config == null || rejection.config.ignoreError) {
                    return;
                }

                $log.error('Error processing request to ' + rejection.config.url + '(' + rejection.status + ')'+'\r\n'+getHttpErrorDetails(rejection));
                if (rejection.status === 503 || rejection.status === 0) {
                    // Service unavailable, pop up a warning mentioning that we may be doing maintenance
                    // TODO re-enable this
                    //$window.location.href = '/';
                } else if (rejection.status === 500 || rejection.status === 400) {
                    // Something is broken on the server, so just reload the app
                    // TODO need to fix existing issues first and also send error to us first
                    //$window.location.href = '/tradefloor';
                } else if (rejection.status === 401 || rejection.status === 403) {
                    $injector.get('sessionExpiredService');//.openDialog();
                    $injector.get("currentUserService").sessionExpired()
                }
            }

            return {
                // On request failure
                requestError: function (rejection) {
                    // show notification
                    notifyError(rejection);

                    // Return the promise rejection.
                    return $q.reject(rejection);
                },

                // On response failure
                responseError: function (rejection) {
                    // show notification
                    notifyError(rejection);
                    // Return the promise rejection.
                    return $q.reject(rejection);
                }
            };
        }]);

        // Add the interceptor to the $httpProvider.
        $httpProvider.interceptors.push('ErrorHttpInterceptor');

    }])
    .config(['$locationProvider', function configureLocationProvider($locationProvider) {
        //$locationProvider.html5Mode(true);
    }])
    .config(['$stateProvider', 'userConfigProvider', function configureRoutes($stateProvider, userConfigProvider) {

        if (!userConfigProvider.config.loggedIn) {
            return;
        }

        const hasEquityOrders = userConfigProvider.config.features['SCREEN_EQUITY_ORDERS'];
        const hasOptionOrders = userConfigProvider.config.features['SCREEN_OPTION_ORDERS'];
        userConfigProvider.config.viewOrdersEnabled = hasEquityOrders || hasOptionOrders || false;
        userConfigProvider.config.ordersEnabled = userConfigProvider.config.features['FEATURE_ORDER_ENTRY'] || false;
        userConfigProvider.config.livePrices = userConfigProvider.config.features['FEATURE_LIVE_PRICES'] ||
            userConfigProvider.config.features['FEATURE_DEMO_PRICES'] || false;

        $stateProvider.state('join', {
            url: '/join/{name}?code',
            template: '',
            controller: 'autoJoinLeagueCtrl as autoJoin',
            data: {
                pageTitle: '{TradeFloor} - Join League'
            },
            params: {
                name: null,
                code: null
            }
        });

        $stateProvider.state('alerts', {
            url: '/alerts',
            templateUrl: 'app/alerts/alerts.tpl.html',
            controller: 'alertsCtrl as alerts',
            data: {
                pageTitle: '{TradeFloor} - Alerts'
            }
        });

        if (userConfigProvider.config.branding === 'GAME' ||
            userConfigProvider.config.branding === 'NEWCASTLE') {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'gameWelcomeCtrl as welcome',
                data: {
                    pageTitle: '{TradeFloor} - Welcome'
                }
            });

            $stateProvider.state('portal', {
                url: '/portal',
                templateUrl: 'app/portal/portal.tpl.html',
                controller: 'portalCtrl as portal',
                data: {
                    pageTitle: '{TradeFloor} - Pro Portal'
                }
            });

            $stateProvider.state('home', {
                url: '/',
                templateUrl: 'app/game/game.tpl.html',
                controller: 'gameCtrl as game',
                data: {
                    pageTitle: 'Options Trading Game by TradeFloor, sponsored by ASX.'
                },
                /** @ngInject */
                onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_HOME_PAGE)
            });

            //TODO: Enable this if needed. button also need to be added

            // $stateProvider.state('leagues', {
            //     url: '/leagues',
            //     controller: 'leaderboardCtrl as leaderboard',
            //     templateUrl: 'app/game/partials/leagues/leagues.tpl.html',
            //     data: {
            //         pageTitle: "{TradeFloor} - Leaderboards"
            //     },
            //     params: {
            //         board: null
            //     }
            // });

            // $stateProvider.state('viewleagues', {
            //     url: '/leagues/search',
            //     controller: 'leagueSearchCtrl',
            //     templateUrl: 'app/game/partials/leagues/viewLeagues.tpl.html',
            //     data: {
            //         pageTitle: "{TradeFloor} - Leagues"
            //     },
            // });

            $stateProvider.state('game_over', {
                url: '/game_over',
                templateUrl: 'app/offers/offersGameClosed.tpl.html',
                resolve: {
                    /** ngInject */
                    dates: (asxGameService) => asxGameService.dates()
                },
                controllerAs: 'ctrl',
                controller: ['$uibModal', 'dates', function ($uibModal, dates) {
                    this.dates = dates
                }],
                data: {
                    pageTitle: '{TradeFloor} - Game Over'
                }
            });

            $stateProvider.state("education", {
                url: "/education",
                onEnter: ['$window', function ($window) {
                    $window.location = "/education/";
                }]
            });

        } else if (userConfigProvider.config.branding == 'TC') {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'tcWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'TradersCircle Options Calculator - Welcome'
                }
            });

            $stateProvider.state('home', {
                url: '/',
                templateUrl: 'app/home/home.tpl.html',
                controller: 'homeCtrl as home',
                data: {
                    pageTitle: 'TradersCircle Options Calculator'
                },
                /** @ngInject */
                onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_HOME_PAGE)
            });

        } else if (userConfigProvider.config.branding == Branding.IV) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'ivWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Implied Volatility Options Calculator - Welcome'
                },
                resolve:
                    {
                        idempotency: ['$http', function ($http) {
                            return $http.get('/tradefloor/api/stripe/idempotent').then(function (response) {
                                return response.data.key;
                            });
                        }]
                    }
            });

            $stateProvider.state('openBrokerageAccount', {
                url: '/openAccount',
                templateUrl: 'app/tradeon/openAccount/openAccount.tpl.html',
                controller: 'openAccountCtrl as openAccount',
                data: {
                    pageTitle: 'Open A Brokerage Account'
                }
            });

            $stateProvider.state("education", {
                url: "/education",
                onEnter: ['$window', function ($window) {
                    $window.location = "/education/";
                }]
            });

            $stateProvider.state("trading-dashboard", {
                url: "/trading-dashboard?view",
                component: DashboardView,
                data: {
                    pageTitle: "Trading Dashboard"
                },
                params: {
                    view: {
                        dynamic: true,
                        type: "int"
                    }
                }
            });

        } else if (userConfigProvider.config.branding === Branding.IINVEST) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'iinvestWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'iInvest Options Calculator - Welcome'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.OPEN_TRADER) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'openTraderWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Opentrader - Welcome'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.OPEN_MARKETS) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'omWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'OpenMarkets - Welcome'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.BELLMONT) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'bellmontWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Bellmont Securities - Welcome'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.FUTURE_ASSIST) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'futureAssistWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Future Assist - Welcome'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.ALLFIN) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'allfinWelcomeCtrl as welcome',
                data: {
                    pageTitle: ' 澳财证券'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.WAIMAK) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'waimakWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Waimak - Welcome'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.SUUBEE) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'suubeeWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Suubee Premium - Welcome'
                }
            });
        } else if (userConfigProvider.config.backOffice === "PHILLIP" && userConfigProvider.config.branding === Branding.TF) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'fxeWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Tradefloor - Welcome'
                }
            });
        } else if (userConfigProvider.config.branding === Branding.LIQUIDITY) {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'liquidityWelcomeCtrl as welcome',
                data: {
                    pageTitle: 'Liquidity - Welcome'
                }
            });
        } else {
            $stateProvider.state('welcome', {
                url: '/welcome',
                template: '',
                controller: 'welcomeCtrl as welcome',
                data: {
                    pageTitle: '{TradeFloor} - Welcome'
                }
            });
        }

        // TODO setup routes based on default pages and what not

        $stateProvider.state('support', {
            url: '/support',
            templateUrl: 'app/support/support.tpl.html',
            controller: 'supportCtrl as support',
            data: {
                pageTitle: 'Support Manager'
            }
        });

        $stateProvider.state('hedgeHelper', {
            url: '/hedgeHelper',
            templateUrl: 'app/hedgehelper/hedgehelper.tpl.html',
            controller: 'hedgeHelperCtrl as hedgeHelper',
            data: {
                pageTitle: 'Hedge Helper'
            }
        });


        $stateProvider.state('strategy', {
            url: '/strategy?clone&underlying',
            templateUrl: 'app/strategybuilder/strategy.tpl.html',
            controller: 'strategyCtrl as strategy',
            data: {
                pageTitle: 'Strategy Builder'
            },
            params: {
                underlying: null,
                activeStrategy: null,
                fromIntro: false,
                noUnderlying: false
            },
            resolve: {
                brokers: ['brokersService', function (brokersService) {
                    return brokersService.getBrokers();
                }]
            },
            /** @ngInject */
            onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_STRATEGY_BUILDER)
        });

        $stateProvider.state('operator', {
            url: '/operator',
            templateUrl: 'app/blotter/operator.tpl.html',
            controller: 'blotterCtrl as blotter',
            data: {
                pageTitle: 'Operator Blotter'
            }
        });

        $stateProvider.state('audit', {
            url: '/audit',
            templateUrl: 'app/audit/audit.tpl.html',
            controller: 'auditCtrl as audit',
            data: {
                pageTitle: 'Audit'
            }
        });
        if (userConfigProvider.config.viewOrdersEnabled) {
            $stateProvider.state('orders', {
                url: '/orders',
                component: OrdersView,
                data: {
                    pageTitle: 'Orders'
                },
                /** @ngInject */
                onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_ORDERS)
            });
        }

        $stateProvider.state('process', {
            url: '/process',
            templateUrl: 'app/process/process.tpl.html',
            controller: 'processCtrl as process',
            data: {
                pageTitle: 'Process Control'
            }
        });

        $stateProvider.state('chain', {
            url: '/chain',
            templateUrl: 'app/chain/optnChain.tpl.html',
            controller: 'optnChainCtrl as chain',
            data: {
                pageTitle: 'Options Chain'
            }
        });

        $stateProvider.state('admin', {
            url: '/admin',
            templateUrl: 'app/admin/admin.tpl.html',
            controller: 'adminCtrl as admin',
            data: {
                pageTitle: 'Administration Panel'
            }
        });

        $stateProvider.state('charting', {
            url: '/charting?symbol',
            templateUrl: 'app/apps/charting/charting.tpl.html',
            controller: 'chartingCtrl as chart',
            data: {
                pageTitle: 'Charting Portal'
            },
            /** @ngInject */
            onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_CHARTING)
        });

        $stateProvider.state("admin.password", {
                url: "/password",
                templateUrl: "app/admin/password/password.tpl.html"
            }
        );

        $stateProvider.state("admin.userMaintenance", {
                url: "/userMaintenance",
                controller: "userMaintenanceCtrl as userMaintenance",
                templateUrl: "app/admin/userMaintenance/userMaintenance.tpl.html"
            }
        );

        $stateProvider.state("admin.userlist", {
                url: "/userlist",
                controller: "userMaintenanceCtrl as userMaintenance",
                templateUrl: "app/admin/userlist/userList.tpl.html"
            }
        );

        $stateProvider.state("admin.additionalSettings", {
                url: "/additionalSettings",
                controller: "additionalSettingsCtrl as additionalSettings",
                templateUrl: "app/admin/additionalSettings/additionalSettings.tpl.html"
            }
        );

        $stateProvider.state("admin.gameDashboard", {
                url: "/gamedashboard",
                controller: "gameDashboardCtrl as gameDashboard",
                templateUrl: "app/admin/gameDashboard/gameDashboard.tpl.html"
            }
        );

        $stateProvider.state('volatility', {
            url: '/volatility',
            templateUrl: 'app/volatility/voltools.tpl.html',
            controller: 'volatilityCtrl as volatility',
            data: {
                pageTitle: 'Volatility Tools'
            }
        });


        $stateProvider
            .state('viewprofile', {
                url: '/viewprofile/{userId:int}',
                templateUrl: 'app/profile/view/profile.tpl.html',
                controller: 'profileViewCtrl',
                data: {
                    pageTitle: 'Profile'
                },
                resolve: {
                    profile: ['$http', '$stateParams', function ($http, $stateParams) {
                        return $http.get('/tradefloor/api/user/' + $stateParams.userId + '/profile/public').then(function (response) {
                            return response.data;
                        });
                    }]
                }
            });

        $stateProvider
            .state('viewbrokerprofile', {
                url: '/viewbroker/{userId:int}',
                templateUrl: 'app/profile/view/profileBroker.tpl.html',
                controller: 'profileBrokerViewCtrl',
                data: {
                    pageTitle: 'Profile'
                }
            });

        $stateProvider
            .state('profile', {
                url: '/profile',
                templateUrl: 'app/profile/profile.tpl.html',
                controller: 'profileCtrl',
                data: {
                    pageTitle: 'Profile'
                }
            })

            .state('profile.main', {
                url: '/main',
                templateUrl: 'app/profile/profile_main.tpl.html'
            })

            .state('profile.edit', {
                url: '/edit',
                templateUrl: 'app/profile/profile_edit.tpl.html',
                controller: 'profileEditCtrl',
                resolve: {
                    demographics: ['$http', 'userConfig', function ($http, userConfig) {
                        return $http.get('/tradefloor/api/user/demographics').then(function (response) {
                            return response.data;
                        });
                    }],
                    profile: ['$http', 'userConfig', function ($http, userConfig) {
                        return $http.get('/tradefloor/api/user/' + userConfig.id + '/profile').then(function (response) {
                            return response.data;
                        });
                    }]
                }
            })

            .state('profile.settings', {
                url: '/settings/{setting:string}?',
                templateUrl: 'app/profile/profile_settings.tpl.html',
                controller: 'settingsCtrl as settings',
                params: {
                    setting: null
                }
            });

        $stateProvider
            .state('profileTO', {
                url: '/accountmanagement',
                templateUrl: 'app/profile/tradeon/profile.tpl.html',
                controller: 'profileCtrl',
                data: {
                    pageTitle: 'Profile'
                }
            })

            .state('profileTO.main', {
                url: '/main',
                templateUrl: 'app/profile/profile_main.tpl.html'
            })

            .state('profileTO.edit', {
                url: '/edit',
                templateUrl: 'app/profile/profile_edit.tpl.html',
                controller: 'profileEditCtrl',
                resolve: {
                    demographics: ['$http', 'userConfig', function ($http, userConfig) {
                        return $http.get('/tradefloor/api/user/demographics').then(function (response) {
                            return response.data;
                        });
                    }],
                    profile: ['$http', 'userConfig', function ($http, userConfig) {
                        return $http.get('/tradefloor/api/user/' + userConfig.id + '/profile').then(function (response) {
                            return response.data;
                        });
                    }]
                }
            })

            .state('profileTO.settings', {
                url: '/settings/{setting:string}?',
                templateUrl: 'app/profile/tradeon/profile_settings.tpl.html',
                controller: 'settingsCtrl as settings'
            });

        $stateProvider.state('billing', {
            url: '/billing',
            templateUrl: 'app/profile/profile_billing.tpl.html',
            controller: 'billingCtrl as billing',
            data: {
                pageTitle: 'Subscriptions & Billing'
            },
            resolve: {
                billing: ['$http', function ($http) {
                    return $http.get('/tradefloor/api/stripe/billing').then(function (response) {
                        return response.data;
                    });
                }],
                subscriptions: ['$http', function ($http) {
                    return $http.get('/tradefloor/api/stripe/subscriptions').then(function (response) {
                        return response.data.subscriptions;
                    })
                }]
            }
        });

        $stateProvider.state('settings', {
            url: '/settings',
            templateUrl: 'app/settings/settings.tpl.html',
            controller: 'settingsCtrl as settings',
            data: {
                pageTitle: 'Settings'
            }
        });

        $stateProvider.state('newAccount', {
            url: '/newAccount',
            templateUrl: 'app/layout/newAccount/newAccount.tpl.html',
            controller: 'newAccountCtrl as newAccountCtrl',
            data: {
                pageTitle: 'New Account'
            }
        });
    }])
    .run(['$rootScope', '$state', '$stateParams', '$timeout', '$window', 'userConfig', '$http', '$transitions', 'orderStatusService', 'asxGameService', "orderNotificationService", function ($rootScope, $state, $stateParams, $timeout, $window, userConfig, $http, $transitions, orderStatusService, asxGameService, orderNotificationService) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.userConfig = userConfig;

        orderStatusService.start();
        orderNotificationService.start();

        $rootScope.goToImpliedVolatility = function () {
            $window.location.href = 'https://impliedvolatility.com.au/#/signup';
        };

        $rootScope.goToTradeFloor = function () {
            $window.location.href = 'https://tradefloor.com.au/#/signup';
        };

        $rootScope.$on('widget.collapsed', function (event, param) {
            $timeout(function () {
                //$($window).trigger('resize');
                $window.dispatchEvent(new Event('resize'));
            }, 0);
        });
        //$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
        //    // TODO HACK Force full refresh due to dynamic margins on the left
        //    // This shouldn't be required if we we updated the nav bar (and flowed) then changed the state
        //    $timeout(function () {
        //        $($window).trigger('resize');
        //    }, 10);
        //});

        // NVD3 or angular-nv has a leak where they aren't able to clean up one of the tooltips they create
        // so we're going to clean them all up on a successful transition just to be sure
        $transitions.onStart({}, function cleanUpTooltips() {
            NVD3Util.nukeAllTooltips();
            return true;
        });

        $transitions.onStart({ to: "strategy" }, function strategyBuilderTransitionGuard(transition) {
            const $state = transition.router.stateService;
            if (userConfig.features['SCREEN_STRATEGY_BUILDER'] != null) {
                return true;
            } else {
                return $state.target("home")
            }
        });

        $transitions.onStart({ to: "charting" }, function chartingTransitionGuard(transition) {
            const $state = transition.router.stateService;
            if (userConfig.backOffice === "PHILLIP" || userConfig.features['FEATURE_ADV_CHARTING'] != null) {
                return true;
            } else {
                return $state.target("home")
            }
        });

        if (userConfig.branding === 'GAME' ||
            userConfig.branding === 'NEWCASTLE') {

            $transitions.onStart({to: "*"}, async function gameOverTransitionGuard(transition) {
                const to = transition.to();
                const $state = transition.router.stateService;

                if (userConfig.support != null) {
                    return true;
                }

                if (to.name === 'game_over') {
                    return true;
                }

                if (to.name === 'welcome') {
                    return true;
                }

                if (to.name === 'join') {
                    return true;
                }

                const dates = await asxGameService.dates();

                if (dates.isOpen || dates.isPreOpen) {
                    return true;
                } else {
                    if (userConfig.client && !userConfig.client.onBoarded) {
                        return $state.target('welcome');
                    }

                    return $state.target('game_over')
                }
            });
        }
    }
    ])
    .factory('Excel', ['$window', function ($window) {
        var uri = 'data:application/vnd.ms-excel;base64,',
            template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64 = function (s) { return $window.btoa(unescape(encodeURIComponent(s))); },
            format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };
        return {
            tableToExcel: function (tableId, worksheetName) {
                var table = document.querySelector(tableId),
                    ctx = { worksheet: worksheetName, table: table.innerHTML },
                    href = uri + base64(format(template, ctx));
                return href;
            }
        };
    }])
    .config(['$uibTooltipProvider', function ($uibTooltipProvider) {
        $uibTooltipProvider.options({ popupDelay: 500, appendToBody: true });
    }])
    .run(function () {
        if(FastClick != undefined) {
            FastClick.attach(document.body);
        }
    })
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('tf-ui-grid/ui-grid-row',`
<div ng-if="!(colContainer.name === 'body' && row.groupHeader)"
context-menu="grid.appScope.gridContextMenu">
     <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid"
         ui-grid-one-bind-id-grid="rowRenderIndex + '-' + col.uid + '-cell'"
         class="ui-grid-cell" ng-class="{ 'ui-grid-row-header-cell': col.isRowHeader }"
         role="{{col.isRowHeader ? 'rowheader' : 'gridcell'}}"
         ui-grid-cell>
    </div>
</div>
<div ng-if="colContainer.name === 'body' && row.groupHeader" class="position-description-cell">
    <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid"
         ui-grid-one-bind-id-grid="rowRenderIndex + '-' + col.uid + '-cell'"
         class="ui-grid-cell" ng-class="{ 'ui-grid-row-header-cell': col.isRowHeader }"
         role="{{col.isRowHeader ? 'rowheader' : 'gridcell'}}"
         ui-grid-cell>
    </div>
    <div ng-class="{'opacity1': grid.appScope.isSecuritySelected(row.treeNode)}" class="position-controls">

        <button type="button" class="btn-md btn-clear"
                ng-click="grid.appScope.closePositions()">
            <i class="icon-circle-cross"></i>
            <span class="add-btn-name">Close selected</span>
        </button>

        <button type="button" class="btn-md btn-clear"
                ng-click="grid.appScope.closeRollPositions()">
            <i class="icon-share3"></i>
            <span class="add-btn-name">Roll selected</span>
        </button>
    </div>
</div>
`
    )}])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put("uib/template/modal/fs-window.html",
            "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div id=\"fs-scroll-container\" du-scroll-container class=\"modal-content\" style=\"overflow-y: auto; overflow-x: hidden; border:none;\" uib-modal-transclude></div></div>\n" +
            "");
    }])
    // TODO this will need to be checked on every release of ui-grid
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('templates/growl/growl.html', '<div class="growl-container" ng-class="wrapperClasses()">' +
            '<div class="growl-item bigBox" ng-repeat="message in growlMessages.directives[referenceId].messages" ng-class="alertClasses(message)" ng-click="growlMessages.deleteMessage(message)" >' +
            '<div class="bigboxicon"><i style="display: inline-block" class="icon-bell animated swing"></i></div>' +
            '<span ng-show="message.title" ng-bind-html="message.title"></span>' +
            '<p ng-bind-html="message.text"></p>' +
            '</div>' +
            '</div>');
    }])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('tf/uiGridHeaderCell',
            "<div ng-class=\"{ 'sortable': sortable }\"><!-- <div class=\"ui-grid-vertical-bar\">&nbsp;</div> --><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><span term=\"col.colDef.term\">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-visible=\"col.sort.direction\" ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\">&nbsp;</span></div><div class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event)\" ng-class=\"{'ui-grid-column-menu-button-last-col': isLastCol}\"><i class=\"ui-grid-icon-angle-down\">&nbsp;</i></div><div ui-grid-filter></div></div>"
        );
    }])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('template/datepicker/month.html',
            "<table role=\"grid\" class=\"date-picker noFocus\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">" +
            "    <thead>" +
            "    <tr>" +
            "    <th><button type=\"button\" class=\"btn btn-clear btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"icon-angle-double-left\"></i></button></th>" +
            "    <th><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>" +
            "<th><button type=\"button\" class=\"btn btn-clear btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"icon-angle-double-right\"></i></button></th>" +
            "    </tr>" +
            "    </thead>" +
            "    <tbody>" +
            "    <tr ng-repeat=\"row in rows track by $index\">" +
            "    <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">" +
            "    <button type=\"button\" style=\"width:100%;\" class=\"btn\" ng-class=\"{'btn-clear' : !isActive(dt), 'btn-default' : isActive(dt), 'active': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>" +
            "</td>" +
            "</tr>" +
            "</tbody>" +
            "</table>"
        );

        $templateCache.put("uib/template/rating/rating.html",
            "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
            "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
            "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" aria-valuetext=\"{{r.title}}\"></i>\n" +
            "</span>\n" +
            "");
    }])
    .config(['$urlRouterProvider', 'userConfigProvider', '$injector', function($urlRouterProvider, userConfigProvider, $injector) {
            $urlRouterProvider.otherwise(() => {
                if (userConfigProvider.config.loggedIn) {
                    return "/"
                } else {
                    return $injector.get('sessionExpiredService');//.openDialog();
                }
            })
    }])
    .run(['$state', 'userConfig', '$uibModal', '$window', '$localStorage', '$transitions', '$timeout', function ($state, userConfig, $uibModal, $window, $localStorage, $transitions, $timeout) {

        var termDate = new Date('2015-05-26:00:00:00 +10:00');
        var privacyDate = new Date('2016-11-15:00:00:00 +11:00');

        //if (userConfig.client && (!userConfig.legal.terms || userConfig.legal.terms < termDate)) {
        //    $state.go('legal');
        //}
        //

        function showIntro() {
            if ((userConfig.branding === 'GAME' || userConfig.branding === 'NEWCASTLE')
                  && !$localStorage.hasShownCourse) {
                $uibModal.open({
                    templateUrl: 'app/game/partials/introCourse/openSplash.tpl.html',
                    controller: 'splashCtrl as splashCtrl',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {}
                });
                $localStorage.hasShownCourse = true;
                $localStorage.$apply();
            }
        }

        if (userConfig.client && (!userConfig.client.legal.privacy || new Date(userConfig.client.legal.privacy).getTime() < privacyDate.getTime())) {
            var modalInstance;
            if(userConfig.branding === Branding.IV){
                modalInstance = $uibModal.open({
                    templateUrl: 'app/privacy/iv/privacy_iv.tpl.html',
                    resolve: {
                    },
                    controller: 'privacyCtrl',
                    size: 'lg',
                    backdrop: 'static'
                });
            } else if(userConfig.branding === Branding.TF){
                modalInstance = $uibModal.open({
                    templateUrl: 'app/privacy/tf/privacy_tf.tpl.html',
                    resolve: {
                    },
                    controller: 'privacyCtrl',
                    size: 'lg',
                    backdrop: 'static'
                });
            }else{
                modalInstance = $uibModal.open({
                    templateUrl: 'app/privacy/privacy.tpl.html',
                    resolve: {
                    },
                    controller: 'privacyCtrl',
                    size: 'lg',
                    backdrop: 'static'
                });
            }

            modalInstance.result.then(function () {
                showIntro();
            }, function () {
                $window.location.href = '/#/';
            });
        } else {
            showIntro();
        }

        var onStart = null;

        onStart = $transitions.onStart({ to: "home" }, function (transition) {
            switch (userConfig.branding) {
                case 'GAME':
                case 'NEWCASTLE':
                    if (userConfig.client && !userConfig.client.onBoarded) {
                        $state.go('welcome');
                    }
                    break;
                case 'TC':
                    if (userConfig.client && !userConfig.client.onBoarded) {
                        $state.go('welcome');
                    } else {
                        if (userConfig.favourites.length === 1) {
                            $state.go('portfolio', { portfolioId: userConfig.favourites[0].id });
                        }
                    }
                    break;
                default:
                    if (userConfig.client && !userConfig.client.onBoarded) {
                        $state.go('welcome');
                    }
                    break;
            }
            $timeout(onStart);
            return true;
        });
    }])
    .controller('privacyCtrl', ['$scope', '$uibModalInstance', '$http', function ($scope, $uibModalInstance, $http) {
        $scope.accept = function () {
            $http.put('/tradefloor/api/user/legal/privacy').then(function () {
                $uibModalInstance.close();
            });
        }
    }])
    .config(['IdleProvider', 'KeepaliveProvider', function (IdleProvider, KeepaliveProvider) {
        IdleProvider.idle(1800); // in seconds
        IdleProvider.timeout(0);
        IdleProvider.keepalive(false);
    }])
    .run(['Idle', function (Idle) {
        // start watching when the app runs. also starts the Keepalive service by default.
        Idle.watch();
    }])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('ng-joyride-tplv1.html',
            "<div class=\"welcomeWizard popover ng-joyride sharp-borders\"><div class=\"arrow\"></div><h3 class=\"popover-title sharp-borders\"><i class=\"icon-cross pull-right \"></i></h3><div class=\"popover-content container-fluid\"></div></div>"
        );
        $templateCache.put('ng-joyride-title-tplv1.html',
            "<div id=\" ng-joyride-title-tplv1\"><div class=\"ng-joyride sharp-borders intro-banner\" style=\"\"><div class=\"popover-inner\"><h3 class=\"popover-title sharp-borders\">{{heading}}<i class=\"icon-cross skipBtnCross pull-right\" ng-click=\"skipDemo()\"></i></h3><div class=\"popover-content container-fluid\"><div ng-bind-html=\"content\"></div><hr><div class=\"row\"><div class=\"col-md-4 skip-class\"><a class=\"skipBtn pull-left\" type=\"button\"><i class=\"icon-power\"></i>&nbsp; Skip Tour</a></div><div class=\"col-md-8\"><div class=\"pull-right\"><button class=\"prevBtn btn btn-clear\" type=\"button\"><i class=\"icon-angle-double-left\"></i>&nbsp;Previous</button> <button id=\"nextTitleBtn\" class=\"nextBtn btn btn-clear\" type=\"button\">Next&nbsp;<i class=\"icon-angle-double-right\"></i></button></div></div></div></div></div></div></div>"
        );

        $templateCache.put('ng-joyride-tplv2.html',
            "<div class=\"welcomeWizard popover ng-joyride sharp-borders\"><div class=\"arrow\"></div><h3 class=\"popover-title sharp-borders\"><i class=\"icon-cross pull-right \"></i></h3><div class=\"popover-content container-fluid\"></div></div>"
        );
        $templateCache.put('ng-joyride-title-tplv2.html',
            "<span class=\"skipBtn skipBtnCross pull-right pointer\" style=\"font-size: 30px; position: absolute; top: 15px; right: 15px; z-index: 10;\"><i class=\"icon-cross\"></i></span><div class=\"welcomeWizard \" style=\"\"><div class=\"modal-body\"><h1 class=\"mb-50 mt-50\">{{heading}}</h1><div class=\"popover-content container-fluid\"><h3 ng-bind-html=\"content\"></h3><div class=\"modal-footer\"><div class=\"buttons-wizard\"><button id=\"nextTitleBtn\" class=\"btn nextBtn btn-lg btn-info\" type=\"button\">Continue</button></div></div></div></div></div></div>"
        );
    }])
    .config(['growlProvider', function (growlProvider) {
        growlProvider.globalTimeToLive(5000);
        growlProvider.globalDisableCountDown(true);
        growlProvider.globalPosition('bottom-right');
        growlProvider.globalDisableCloseButton(true);
        growlProvider.globalDisableIcons(true);
    }])

    .factory('userPrefsFactory', ['$http', '$q', function ($http, $q) {
        var services = {};


        return function (key) {
            var service = services[key];

            if (!service) {

                service = {
                    deferred: null,
                    getPreference: function (defaultValue) {
                        var self = this;
                        if (!self.deferred) {
                            self.deferred = $q.defer();

                            $http.get('/tradefloor/api/user/preferences/' + key).then(function (response) {
                                var data = defaultValue;

                                if (response.status === 200) {
                                    data = response.data;
                                }

                                self.deferred.resolve(data);
                            },
                                function (response) {
                                    self.deferred.reject();
                                });
                        }

                        return self.deferred.promise;
                    },
                    setPreference: function (value) {
                        var self = this;

                        self.deferred = $q.defer();

                        $http.put('/tradefloor/api/user/preferences/' + key, JSON.stringify(value))
                            .then(function (response) {
                                self.deferred.resolve(value);
                            },
                            function (response) {
                                self.deferred.reject();
                            });

                        return self.deferred.promise;

                    }
                };

                services[key] = service;
            }


            return service;

        };
    }])
    .factory('GoogleFeed', ['$http', '$q', '$sce', function ($http, $q, $sce) {
        return {
            load: function (url) {
                var deferred = $q.defer();
                $http.jsonp('//ajax.googleapis.com/ajax/services/feed/load?v=1.0&num=50&callback=JSON_CALLBACK&q=' + encodeURIComponent(url))
                    .then(function (response) {
                        var feed = response.data.responseData.feed;

                        feed.entries.forEach(function (feedEntry) {
                            feedEntry.feed = feed;
                            feedEntry.title = $sce.trustAsHtml(feedEntry.title);
                            feedEntry.contentSnippet = $sce.trustAsHtml(feedEntry.contentSnippet);
                            feedEntry.content = $sce.trustAsHtml(feedEntry.content);
                            feedEntry.publishedDate = new Date(feedEntry.publishedDate).getTime();
                        });

                        deferred.resolve(feed);
                    }, function () {
                        deferred.reject();
                    });

                return deferred.promise;
            }
        }
    }])
    .factory('brokersService', ['$http', function ($http) {
        function htmlify(value) {
            var bold = /“(.*?)”/g;
            var italic = /‘(.*?)’/g;
            value = value.replace(bold, "<b>“$1”</b>")
                         .replace(italic, "<i>‘$1’</i>");

            value = value.replace(/\[(.*?)\]\((.*?)\)/g, '<a target="_blank" href="$1">$2</a>');
            return value.split(/\n/g)
                        .map((line) => line.startsWith("#") ? line.replace(/#\s*(.*)/g, "<h3>$1</h3>") : "<p>" + line + "</p>")
                        .join("");
        }

        var data = $http.get('/tradefloor/api/brokers').then(function (response) {
            var brokers = {};
            response.data.forEach(function (b) {
                brokers[b.broker] = b;
                if (b.disclaimer) {
                    b.disclaimer = htmlify(b.disclaimer);
                }

            });

            return brokers;
        });

        return {
            getBrokers: function () {
                return data;
            }
        };
    }])
    .factory('csv', [function () {
        return {
            parse: parse
        };

        function parse(csv, mapper) {
            mapper = mapper || function (row, rowNumber) { return row; };
            var chars = csv.split(''), c = 0, cc = chars.length, start, end, table = [], row, rowNumber = 0;
            while (c < cc) {
                row = [];
                while (c < cc && '\r' !== chars[c] && '\n' !== chars[c]) {
                    start = end = c;
                    if ('"' === chars[c]) {
                        start = end = ++c;
                        while (c < cc) {
                            if ('"' === chars[c]) {
                                if ('"' !== chars[c + 1]) { break; }
                                else { chars[++c] = ''; } // unescape ""
                            }
                            end = ++c;
                        }
                        if ('"' === chars[c]) { ++c; }
                        while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && ',' !== chars[c]) { ++c; }
                    } else {
                        while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && ',' !== chars[c]) { end = ++c; }
                    }
                    row.push(chars.slice(start, end).join(''));
                    if (',' === chars[c]) { ++c; }
                }
                if ('\r' === chars[c]) { ++c; }
                if ('\n' === chars[c]) { ++c; }

                var mappedValue = mapper(row, rowNumber++);
                if (mappedValue) {
                    table.push(mappedValue);
                }
            }
            return table;
        }
    }])

    .run(["userConfig", "$http", "$rootScope", function(userConfig, $http, $rootScope) {
        userConfig.refresh = async function() {
            const response = await $http.get("/tradefloor/api/user/current-config");
            const config = response.data;
            Object.assign(this, config);

            $rootScope.$applyAsync();
        };
    }])

    .run(["userNotificationPreferencesService", function(userNotificationPreferencesService) {
        userNotificationPreferencesService.enabled
                                          .take(1)
                                          .filter((enabled) => enabled)
                                          .subscribe(() => userNotificationPreferencesService.subscribe())
    }])
    .run(["crispService", function(crispService) {
        crispService.startCrisp();
    }])
     .run(["zenDeskService", function(zenDeskService) {
         zenDeskService.startZenDesk();
     }])
    .run(["ivConversionEventService", function(ivConversionEventService) {
        ivConversionEventService.sendConversionEvent();
    }])
    .run(["gtmConversionEventService", function(gtmConversionEventService) {
        gtmConversionEventService.sendConversionEvent();
   }])
    .run(["accountStore", "$state", function(accountStore, $state) {
        accountStore.current
                    .skip(1) // Ignore any "initial" value that is set here
                    .filter(isNotNull)
                    .map((current) => current.id)
                    .subscribe((id) => $state.go("portfolio", {portfolioId: id}))
    }])
    .run(["themingStore", function (themingStore) {
        themingStore.init();
    }])
    .run(["languageService", "i18nService", function(languageService, i18nService) {
        languageService.current()
                       .subscribe((language) => {
                           switch (language) {
                               case TranslationsLanguage.English:
                                   i18nService.setCurrentLang("en")
                                   break;
                               case TranslationsLanguage.Chinese:
                                   i18nService.setCurrentLang("zh-cn")
                                   break;
                           }
                       })
    }])
    .run([
        "$location", "currentUserService",
        function ($location, currentUserService) {
            if ($location.search()["account-opening"] != null) {
                currentUserService.current
                                  .take(1)
                                  .filter((u) => (u.isClient() && u.isBranding(Branding.OPEN_TRADER)))
                                  .subscribe((u) => {
                                      window.open(getAccountOpeningPath(u.branding(), u) , "_blank");
                                  })
            }
        }
    ]);
